import { NavigationMockApi } from 'app/mock-api/common/navigation/api';

/**
 * Solo queda el mock de NAVEGACION: es de donde sale el menu del layout
 * (NavigationService -> api/common/navigation). Los demas servicios de demo
 * de Fuse (academy, chat, contacts, ecommerce, notifications, etc.) se
 * quitaron en 2026-09: la app no tiene esos modulos y solo pesaban en el
 * bundle.
 */
export const mockApiServices = [NavigationMockApi];
